module.exports = __webpack_public_path__ + "static/media/linkedin.cf54bff9.svg";